<div class="modal-header">
    <div class="modal-title h4" tabindex="-1" ngbAutofocus>Add Link</div>
    <button type="button" class="btn-close" (click)="activeModal.dismiss('crossclick')"></button>
</div>
<div class="modal-body" #vpm>
    <p>Provide a URL to change the selected text into a link.</p>
    <text-input [(obj)]="obj" prop="url"
                label="URL" [labelCols]="4"></text-input>
</div>
<div class="modal-footer">
    <button type="button" class="kf-btn kf-btn-blue" [disabled]="!obj.url?.trim()" (click)="activeModal.close(obj.url)">
        Submit
    </button>
    <button type="button" class="kf-btn kf-btn-light-gray" (click)="activeModal.dismiss('close')">
        Close
    </button>
</div>
